import $ from 'jquery';
var animatedElements = $('.floating-card-animation'); // check if browser is Internet Explorer

var isIE =
/* @cc_on!@ */
false || !!document.documentMode;

var getElPos = function getElPos() {
  var breakpoint = window.cigna.screen.breakpoint;
  var spacing = breakpoint === 'xl' ? 145 : 300;
  var topOfEl = [];
  animatedElements.each(function (i, el) {
    var parentPicture = $(el).parent().find('.floating-card-bg-holder');
    var bottomOfEl = $(parentPicture).offset().top + $(parentPicture).innerHeight() * 0.75;
    var bottomOfView = $(window).scrollTop() + $(window).innerHeight();
    var topOfView = $(window).scrollTop();

    if (topOfView > bottomOfEl) {
      topOfEl.push('ignore');
      $(el).removeClass('animation-delay floating-card-animation');
    } else if (bottomOfView > bottomOfEl && topOfView < bottomOfEl) {
      topOfEl.push('ignore');
      $(el).removeClass('animation-delay');
    } else {
      $(el).removeClass('animation-delay');
      topOfEl.push($(el).outerHeight() + $($(el).parent()).offset().top - spacing);
      $(el).addClass('animation-delay');
    }
  });
  return topOfEl;
};

var showAnimatedElement = function showAnimatedElement(elPos) {
  animatedElements.each(function (i, el) {
    if (!isIE && elPos[i] !== 'ignore') {
      var topOfEl = elPos[i];
      var bottomOfEl = topOfEl + $(el).outerHeight();
      var bottomOfView = $(window).scrollTop() + $(window).innerHeight();
      var topOfView = $(window).scrollTop();
      var breakpoint = window.cigna.screen.breakpoint;

      if (!['xs', 'sm', 'md'].includes(breakpoint)) {
        if (bottomOfView > topOfEl && topOfView < bottomOfEl && $(el).hasClass('animation-delay')) {
          $(el).removeClass('animation-delay');
        }
      } else {
        $(el).removeClass('animation-delay');
      }
    } else {
      $(el).removeClass('animation-delay floating-card-animation');
    }
  });
};

export default (function () {
  var elPos = getElPos();
  showAnimatedElement(elPos);
  $(window).on('scroll', function () {
    showAnimatedElement(elPos);
  });
});